import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  isProcessCanceledByUser,
  Log,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkPriceRateUpdate = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();
  const bulkUpdatePriceRateProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkUpdateBasePrice,
    entity,
  );
  const bulkUpdatePriceRateProcess = useRecoilValue(
    activeProcessSF(bulkUpdatePriceRateProcessKey),
  );

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
      if (isProcessCanceledByUser(process)) {
        return;
      }

      Log.infoAndToast(
        t("general.ENTITY_SUCCESSFULLY_UPDATED", {
          entity: t("priceRate.plural"),
        }),
      );
    },
    [addressedFieldsValueOnCompleted, t],
  );

  useEffect(() => {
    handleProcess({
      entity,
      process: bulkUpdatePriceRateProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      processTitle: RydeProcessTitle.BulkUpdateBasePrice,
    });
  }, [bulkUpdatePriceRateProcess, entity, onComplete, stopProcessPolling, t]);
};
